import Vue from 'vue'
import Router from 'vue-router'
import Error404 from '@/components/Error404'
import Connect from '@/components/Connect'
Vue.use(Router);
export default new Router({
	mode: 'history',
	routes: [
		{ path: '/', name: 'Connect', component: Connect },
		{ path: '*', name: 'Error 404', component: Error404 }
	]
})
